<mat-form-field
  color="accent"
  class="w-100"
>
  <mat-label>Sort by</mat-label>
  <mat-select
    [value]="defaultSortParameter"
    [compareWith]="areSortParamsEqual"
    (selectionChange)="sortParameterChanged.emit($event.value)"
  >
    <mat-option
      *ngFor="let sortParameter of sortParameters"
      [value]="sortParameter"
      class="size-label"
    >
      {{ sortParameter.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
